export const categories = [
    {
    id: 'sofas',
    name: 'Sofas',
    slug: 'sofas',
    description: 'Comfortable and stylish sofas for your living room',
    subcategories: [
      { id: 'sofa-2-seater', name: '2 Seater Sofas', slug: '2-seater-sofas' },
      { id: 'sofa-3-seater', name: '3 Seater Sofas', slug: '3-seater-sofas' },
      { id: 'sofa-sectional', name: 'Sectional Sofas', slug: 'sectional-sofas' },
      { id: 'sofa-recliner', name: 'Recliners', slug: 'recliners' },
      { id: 'sofa-custom', name: 'Customized Sofas', slug: 'customized-sofas' },
    ]
  },
{
    id: 'dressers',
    name: 'Dressers',
    slug: 'dressers',
    description: 'Elegant storage solutions for your bedroom',
    subcategories: [
      { id: 'dresser-4', name: '4 Drawer Dressers', slug: '4-drawer-dressers' },
      { id: 'dresser-6', name: '6 Drawer Dressers', slug: '6-drawer-dressers' },
      { id: 'dresser-7', name: '7 Drawer Dressers', slug: '7-drawer-dressers' },
      { id: 'dresser-8', name: '8 Drawer Dressers', slug: '8-drawer-dressers' },
      { id: 'dresser-10', name: '10 Drawer Dressers', slug: '10-drawer-dressers' },
      { id: 'dresser-12', name: '12 Drawer Dressers', slug: '12-drawer-dressers' },
      { id: 'dresser-custom', name: 'Customized Dressers', slug: 'customized-dressers' },

    ]
  },
  {
    id: 'chest-dressers',
    name: 'Chest Dressers',
    slug: 'chest-dressers',
    description: 'Tall, space-saving storage options',
    subcategories: [
      { id: 'chest-3', name: '3 Drawer Chest', slug: '3-drawer-chest' },
      { id: 'chest-4', name: '4 Drawer Chest', slug: '4-drawer-chest' },
      { id: 'chest-5', name: '5 Drawer Chest', slug: '5-drawer-chest' },
      { id: 'chest-6', name: '6 Drawer Chest', slug: '6-drawer-chest' },
      { id: 'chest-7', name: '7 Drawer Chest', slug: '7-drawer-chest' },
      { id: 'chest-8', name: '8 Drawer Chest', slug: '8-drawer-chest' },
      { id: 'chest-9', name: '9 Drawer Chest', slug: '9-drawer-chest' },
      { id: 'chest-10', name: '10 Drawer Chest', slug: '10-drawer-chest' },
      { id: 'chest-custom', name: 'Customized Chests', slug: 'customized-chests' },

    ]
  },
  {
    id: 'wardrobes',
    name: 'Wardrobes',
    slug: 'wardrobes',
    description: 'Spacious wardrobes for all your clothing needs',
    subcategories: [
      { id: 'wardrobe-2', name: '2 Door Wardrobes', slug: '2-door-wardrobes' },
      { id: 'wardrobe-3', name: '3 Door Wardrobes', slug: '3-door-wardrobes' },
      { id: 'wardrobe-4', name: '4 Door Wardrobes', slug: '4-door-wardrobes' },
      { id: 'wardrobe-5', name: '5 Door Wardrobes', slug: '5-door-wardrobes' },
      { id: 'wardrobe-6', name: '6 Door Wardrobes', slug: '6-door-wardrobes' },
      { id: 'wardrobe-7', name: '7 Door Wardrobes', slug: '7-door-wardrobes' },
      { id: 'wardrobe-8', name: '8 Door Wardrobes', slug: '8-door-wardrobes' },
      { id: 'wardrobe-9', name: '9 Door Wardrobes', slug: '9-door-wardrobes' },
      { id: 'wardrobe-10', name: '10 Door Wardrobes', slug: '10-door-wardrobes' },
      { id: 'wardrobe-custom', name: 'Customized Wardrobes', slug: 'customized-wardrobes' },
    ]
  },
 
   {
    id: 'wooden-beds',
    name: 'Wooden Beds',
    slug: 'wooden-beds',
    description: 'Premium quality wooden bed frames',
    subcategories: [
      { id: 'bed-twin', name: 'Twin Size', slug: 'twin-size' },
      { id: 'bed-double', name: 'Double Size', slug: 'double-size' },
      { id: 'bed-queen', name: 'Queen Size', slug: 'queen-size' },
      { id: 'bed-king', name: 'King Size', slug: 'king-size' },
      { id: 'bed-custom', name: 'Customized Beds', slug: 'customized-beds' },

    ]
  },
  {
    id: 'dresser-mirrors',
    name: 'Dresser Mirrors',
    slug: 'dresser-mirrors',
    description: 'Complete your dresser with matching mirrors',
    subcategories: [
      { id: 'mirror-3', name: '3 Drawer Dresser Mirror', slug: '3-drawer-dresser-mirror' },
      { id: 'mirror-4', name: '4 Drawer Dresser Mirror', slug: '4-drawer-dresser-mirror' },
      { id: 'mirror-5', name: '5 Drawer Dresser Mirror', slug: '5-drawer-dresser-mirror' },
      { id: 'mirror-6', name: '6 Drawer Dresser Mirror', slug: '6-drawer-dresser-mirror' },
      { id: 'mirror-7', name: '7 Drawer Dresser Mirror', slug: '7-drawer-dresser-mirror' },
      { id: 'mirror-8', name: '8 Drawer Dresser Mirror', slug: '8-drawer-dresser-mirror' },
      { id: 'mirror-10', name: '10 Drawer Dresser Mirror', slug: '10-drawer-dresser-mirror' },
      { id: 'mirror-custom', name: 'Customized Dresser Mirrors', slug: 'customized-dresser-mirrors' },

    ]
  },
  {
    id: 'mattresses',
    name: 'Mattresses',
    slug: 'mattresses',
    description: 'Comfortable mattresses for every sleep style',
    subcategories: [
      { id: 'mattress-twin', name: 'Twin Size', slug: 'twin-size' },
      { id: 'mattress-double', name: 'Double Size', slug: 'double-size' },
      { id: 'mattress-queen', name: 'Queen Size', slug: 'queen-size' },
      { id: 'mattress-king', name: 'King Size', slug: 'king-size' },
      { id: 'mattress-custom', name: 'Customized Mattresses', slug: 'customized-mattresses' },

    ]
  },
   {
    id: 'sidetables',
    name: 'Sidetables',
    slug: 'sidetables',
    description: 'Perfect bedside companions',
    subcategories: [
      { id: 'sidetable-2', name: '2 Drawer Sidetables', slug: '2-drawer-sidetables' },
      { id: 'sidetable-3', name: '3 Drawer Sidetables', slug: '3-drawer-sidetables' },
      { id: 'sidetable-4', name: '4 Drawer Sidetables', slug: '4-drawer-sidetables' },
      { id: 'sidetable-5', name: '5 Drawer Sidetables', slug: '5-drawer-sidetables' },
      { id: 'sidetable-6', name: '6 Drawer Sidetables', slug: '6-drawer-sidetables' },
      { id: 'sidetable-custom', name: 'Customized Sidetables', slug: 'customized-sidetables' },

    ]
  },
  {
    id: 'dresser-set',
    name: 'Dresser Set',
    slug: 'dresser-set',
    description: 'Complete your bedroom with matching dresser sets',
    subcategories: []
  },
  {
    id: 'dining-set',
    name: 'Dining Set',
    slug: 'dining-set',
    description: 'Complete dining sets for everyday gatherings',
    subcategories: []
  },
  {
    id: 'bedroom-set',
    name: 'Bedroom Set',
    slug: 'bedroom-set',
    description: 'Coordinated bedroom furniture sets for a cohesive look',
    subcategories: []
  },
  {
    id: 'bookshelves',
    name: 'Bookshelves',
    slug: 'bookshelves',
    description: 'Stylish storage for your books and decor',
    subcategories: []
  },
  {
    id: 'kitchen cabinets',
    name: 'Kitchen Cabinets',
    slug: 'kitchen cabinets',
    description: 'Functional kitchen storage solutions',
    subcategories: []
  },
  {
    id: 'headboards',
    name: 'Headboards',
    slug: 'headboards',
    description: 'Transform your bedroom with elegant headboards',
    subcategories: []
  },
  {
    id: 'tv-stands',
    name: 'Tv-Stands',
    slug: 'tv-stands',
    description: '',
    subcategories: []
  },
  {
    id: 'custom-furniture',
    name: 'Custom Furniture',
    slug: 'custom-furniture',
    description: 'Bespoke furniture tailored to your needs',
    subcategories: []
  }
];
